import { styled } from 'styled-components';

import useDeleteUser from './hooks/useDeleteUser';
import Input from 'components/ui/Input';
import FormRow from 'components/FormRow';
import Modal, { ModalForm, ModalHeader } from 'components/Modal';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.span`
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: 500;
`;

const DeleteText = styled.span`
  margin-bottom: 10px;
  b {
    font-weight: 500;
  }
`;

const UserDeleteModal = () => {
  const {
    useFormReturn: {
      formState: { isSubmitting, errors },
      register,
      handleSubmit,
    },
    isLoading,
    onValid,
  } = useDeleteUser();

  return (
    <Modal maxWidth={480}>
      <ModalHeader>계정 삭제</ModalHeader>
      <ModalForm isLoading={isLoading || isSubmitting} buttonText="계정 삭제하기" onSubmit={handleSubmit(onValid)}>
        <Container>
          <Title>정말 삭제하시겠어요?</Title>
          <span>계정을 삭제하면 계정과 연결된 모든 정보가 삭제되고 복구할 수 없어요</span>
          <DeleteText>삭제를 원하시면 비밀번호를 입력해주세요</DeleteText>
          <FormRow error={errors?.password?.message}>
            <Input {...register('password')} type="password" />
          </FormRow>
        </Container>
      </ModalForm>
    </Modal>
  );
};

export default UserDeleteModal;
